<template>
  <div class="page">
    <QC_Header></QC_Header>
    <div class="page-content">
      <div v-if="!$route.meta.hideMenu" class="page-left-box">
        <QC_Menu></QC_Menu>
      </div>
      <div class="page-right-box">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component v-if="$route.meta&&$route.meta.keepAlive" :key="$route.name" :is="Component" />
          </keep-alive>
          <component v-if="!($route.meta&&$route.meta.keepAlive)" :key="$route.name"  :is="Component" />
        </router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import QC_Header from "../components/home/header";
  import QC_Menu from "../components/home/menu";
  import QC_Footer from "../components/home/footer";
  export default {
    name: "home",
    components: {QC_Footer, QC_Menu, QC_Header},
    computed:{
      user:function(){
        return this.$store.state.user;
      }
    },
    data() {
      return {
        org:{},
        source:source,
      }
    },
    methods: {
      handleMessage(result) {

      }
    },
    mounted() {

    },
    destroyed() {

    }
  }
</script>


<style lang="less" scoped>
  .page{
    display: flex;
    flex-direction: column;
    background-color: #EEF2FB;
    height: 100vh;
    overflow: hidden;
    .page-content{
      flex: 1;
      display: flex;
      min-height: calc(100vh - 60px);
      .page-left-box{
        width: 200px;
        background: #FFFFFF;
        overflow-y: auto;
        box-sizing: border-box;
      }
      .page-right-box{
        flex: 1;
        overflow-y:auto;
        margin-bottom: 30px;
      }
    }
  }



</style>
